<template>
  <svg viewBox="0 0 120 200" role="img" aria-hidden="true">
    <rect x="10" y="4" width="100" height="192" rx="16" fill="#37474f" />
    <rect x="16" y="10" width="88" height="180" rx="12" fill="#263238" />
    <circle cx="60" cy="26" r="9" fill="#111" />
    <circle cx="60" cy="26" r="4" fill="#455a64" />
    <rect x="24" y="46" width="72" height="72" rx="6" fill="#0d1b2a" />
    <circle cx="60" cy="72" r="13" fill="none" stroke="#4dd0e1" stroke-width="3" />
    <path d="M34 112 Q60 84 86 112" fill="none" stroke="#4dd0e1" stroke-width="3" />
    <rect x="32" y="130" width="56" height="30" rx="6" fill="none" stroke="#78909c" stroke-width="2" />
    <path d="M48 152 Q60 138 72 152 M54 152 Q60 145 66 152" fill="none" stroke="#78909c" stroke-width="2" />
    <circle cx="60" cy="176" r="6" :fill="color" />
  </svg>
</template>

<script>
export default {
  name: 'FacialIllustration',
  props: {
    color: { type: String, default: '#9e9e9e' }
  }
}
</script>
